import styled from 'styled-components';
import DefaultIcon from '../Assets/NetRevenusIcon.svg';
import { Body1 } from "../style-comps/Common.styles";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 550px;
  height: 300px;
  position: relative;
  gap: 10px;

  @media (max-width: 768px) {
     width: 100%;
     height: auto;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReservationsText = styled(Body1)`
  margin: 0;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 24px;
  height: 24px;
  background-image: url(${(props) => props.icon || DefaultIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 30px 0 30px;
`;
